<template>
  <v-card outlined >
    <v-container>
    <v-form ref="careerForm">
      <v-row >
        <v-col cols="10" offset="1">
          <v-row>
            <v-col cols="8" class="py-0">
              <TextField
                      v-model="company"
                      :name="label('company')"
                      :max="100"
                      required
              />
            </v-col>
            <v-col cols="4" class="py-0">
              <SelectField
                    v-model="employmentStatus"
                    :name="label('empolymentStatus')"
                    :items="candidateEmploymentStatus"
                    required
                    :submit="submit"
              />
            </v-col>
          </v-row>
          <TextArea
                v-model="position"
                :name="label('position')"
                simple
                :rows="3"
                :max="255"
                style="margin-bottom: 30px"
          />
          <v-row justify="space-around" align="center" no-gutters>
            <v-col cols="3" style="margin-bottom:30px">
              {{label('period')}}
            </v-col>
            <v-col cols="4">
              <DateField
                      v-model="startDate"
                      type="month"
                      :name="label('periodStartDate')"
                      required
              />
            </v-col>
            <v-col cols="1"  style="margin-bottom:30px">
              <v-divider />
            </v-col>
            <v-col cols="4">
              <EndDateField
                      v-model="endDate"
                      type="month"
                      :name="label('periodEndDate')"
                      required
                      @toggleCurrentJob="toggleCurrentJob"
              />
            </v-col>
          </v-row>
          <TextArea
                  v-model="jobDetail"
                  :name="label('jobDetail')"
                  :max="2000"
                  required
          />
        </v-col>
      </v-row>
    </v-form>
    <v-row justify="space-around" class="mb-4" v-if="index === null">
      <v-btn width="100" small depressed outlined color="primary" @click="add">{{label('add')}}</v-btn>
      <v-btn width="100" small depressed outlined color="#7aabcc" @click="cancelAdd">{{label('cancel')}}</v-btn>
    </v-row>
    <v-row justify="space-around" class="mb-4" v-else>
      <v-btn width="100" small depressed outlined color="secondary" @click="update">{{label('update')}}</v-btn>
      <v-btn width="100" small depressed outlined color="#7aabcc" @click="cancelUpdate">{{label('cancel')}}</v-btn>
      <v-btn width="100" small depressed outlined color="error" @click="deleteCareerHistory">{{label("delete")}}</v-btn>
    </v-row>
    </v-container>
  </v-card>
</template>

<script>
  import TextField from "../atoms/TextField";
  import TextArea from "../atoms/TextArea";
  import DateField from "../atoms/DateField"
  import ComponentMixin from "../ComponentMixin";
  import {mapGetters} from "vuex";
  import _clone from "lodash/clone"
  import SelectField from "../atoms/SelectField";
  import EndDateField from "../molecules/EndDateField";

  export default {
    mixins: [ComponentMixin],
    type: "organism",
    name: "CareerHistoryForm",
    props: {
      "value": {
        type: Object,
        default: () => ({})
      },
      "index": {
        type: Number,
        default: null
      }
    },
    data() {
      return {
        id: this.value.id,
        company: this.value.company,
        employmentStatus: this.value.employmentStatus,
        position: this.value.position,
        isCurrentJob: this.value.isCurrentJob || false,
        startDate: this.value.startDate,
        endDate: this.value.endDate,
        jobDetail: this.value.jobDetail
      };
    },
    computed: {
      ...mapGetters("system", ["consts"]),
      isCurrent () {
        return this.isCurrentJob;
      },
      candidateEmploymentStatus () {
        return this.consts.candidateEmploymentStatus
      }
    },
    methods: {
      toggleCurrentJob (value) {
        this.isCurrentJob = value
      },
      onUpdateIsPartTime(value) {
        this.isPartTime = value;
      },
      submit () {
      },
      add () {
        if (this.$refs.careerForm.validate()){
          this.$data.company = `${this.$data.company}`
          this.$emit("add", _clone(this.$data));
        this.$refs.careerForm.reset();
        }
      },
      update () {
        if (this.$refs.careerForm.validate()){
          this.$emit("update", this.$data, this.index)
        }
      },
      cancelAdd () {
        this.$refs.careerForm.reset();
      },
      cancelUpdate () {
        this.$emit("cancelUpdate")
      },
      deleteCareerHistory () {
        this.$emit("delete", this.index)
      },
    },
    components: {
      DateField,
      TextField,
      TextArea,
      SelectField,
      EndDateField,
    }
  }
</script>

<style scoped>

</style>
